<template>
  <v-dialog v-model="dialogOtp" width="500" persistent>
    <v-card rounded="lg">
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("microsite.otpVerified") }}
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          class="justify-center"
        >
          <h4 class="mt-4 blue-grey--text text--darken-2">
            {{ $t("microsite.sendRefCodeOtp") }}: {{ ref_code }}
          </h4>
          <v-col class="ma-auto position-relative" style="max-width: 250px">
            <v-otp-input
              v-model="otpCode"
              :rules="otpRules"
              length="6"
              type="number"
              plain
              required
              outlined
              :disabled="loading"
              @finish="checkOTP()"
            ></v-otp-input>
          </v-col>
          <p class="text-caption">
            {{ $t("microsite.textRequireOTPAgain") }}
            {{ formattedTimeLeft }}
          </p>
          <v-btn
            x-small
            text
            color="red"
            class="text-center"
            @click="sendOTP"
            :disabled="disableBtnOTP"
          >
            {{ $t("microsite.requestOtpAgain") }}

            <v-icon x-small> mdi-sync </v-icon>
          </v-btn>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="checkOTP()">{{
          $t("microsite.confirmDefault")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialogVerifyOtp",
  props: {
    dialogOtp: {
      type: Boolean,
      default: false,
    },
    ref_code: {
      type: String,
      default: "",
    },
    site: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      otpCode: "",
      valid: false,
      loading: false,
      disableBtnOTP: true,
      timeLeft: 60, // seconds
      timer: null,
    };
  },
  computed: {
    otpRules() {
      return [
        (v) => !!v || this.$t("microsite.enterOTP"),
        (v) => v.length === 6 || this.$t("microsite.otpInvalid"),
      ];
    },
    formattedTimeLeft() {
      return `${Math.floor(this.timeLeft / 60)}:${(
        "0" +
        (this.timeLeft % 60)
      ).slice(-2)}`;
    },
  },
  watch: {
    dialogOtp(newVal) {
      if (newVal) {
        this.startTimer();
      } else {
        this.stopTimer();
        this.valid = false;
      }
    },
  },
  methods: {
    startTimer() {
      this.timeLeft = 60;
      this.disableBtnOTP = true;
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          clearInterval(this.timer);
          this.disableBtnOTP = false;
        }
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
    },
    sendOTP() {
      this.$emit("sendOtp");
      this.otpCode = "";
      this.startTimer();
    },
    checkOTP() {
      if (this.$refs.form.validate()) {
        this.$emit("verifyOtp", this.otpCode);
      }
    },
    clearOTP() {
      this.otpCode = "";
    },
  },
};
</script>
